var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Carousel',{attrs:{"perPage":_vm.perPage,"autoplay":_vm.autoplay,"autoplayHoverPause":_vm.autoplayHoverPause,"loop":_vm.loop,"paginationEnabled":_vm.paginationEnabled,"autoplayTimeout":_vm.autoplayTimeout}},_vm._l((_vm.pics),function(pic){return _c('Slide',{key:pic,staticClass:"slide"},[_c('img',{staticClass:"image w-100",attrs:{"src":pic}})])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1460261a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Carousel.vue
// module id = null
// module chunks = 